import React from "react";
import PanelHead from "../../UI/Panel/PanelHead";
import PanelBody from "../../UI/Panel/PanelBody";
import { BannerTable } from "../../UI/Advertising/banner/BannerTable";

const BannerPanel = () => {
  return (
    <div>
      <PanelHead title="Main Page" />
      <PanelBody content={<BannerTable />} />
    </div>
  );
};

export default React.memo(BannerPanel);
